module.exports = __webpack_public_path__ + "img/COMBO HEART RED.42aa5e5.svg";